if (typeof ToastsComponent !== 'function') {
	class ToastsComponent extends HTMLElement {
		constructor() {
			super();

			this.showAfter = this.dataset.showAfter ? this.dataset.showAfter * 1000 : 0;
			this.ref = this.dataset.ref ?? null;
			this.type = this.dataset.type ?? null;
			this.closeAfter = this.dataset.closeAfter ? this.dataset.closeAfter * 1000 : 0;

			this.selectors = {
				toast: '.toast-item',
				close: '[data-toast-close]',
			};

			this.classes = {
				visible: 'toast-item--visible',
			};

			this.toast = this.querySelector(this.selectors.toast);
			this.closeButton = this.querySelector(this.selectors.close);

			this.init();
		}

		init() {
			if (this.type === 'cookies') {
				this.loadFeatures();
			}

			this.showToast();
			this.bindEvents();
		}

		bindEvents() {
			if (!this.closeButton) return;

			if (this.type === 'cookies') {
				this.closeButton.addEventListener('click', () => this.handleAccept());
			} else {
				this.closeButton.addEventListener('click', () => this.closeToast());
			}
		}

		showToast() {
			if (this.toastFound()) return;

			if (this.type === 'cookies') {
				this.onPageLoad(() => {
					const { userCanBeTracked, getTrackingConsent } = window.Shopify.customerPrivacy;

					if (!userCanBeTracked() && getTrackingConsent() === 'no_interaction') {
						setTimeout(() => this.reveal(), this.showAfter);
					}
				});
			} else if (this.type === 'subscription') {
				this.onPageLoad(() => {
					const customerPosted = new URLSearchParams(window.location.search).get('customer_posted');

					if (customerPosted === 'true') {
						this.reveal();
					}
				});
			} else {
				setTimeout(() => this.reveal(), this.showAfter);
			}
		}

		reveal() {
			this.toast.classList.add(this.classes.visible);

			if (this.closeAfter > 0) {
				setTimeout(() => this.closeToast(), this.closeAfter);
			}
		}

		closeToast() {
			if (this.toastFound()) return;

			if (this.type !== 'subscription') {
				const toasts = this.getStoredToasts();
				toasts.push(this.ref);
				localStorage.setItem('toasts', JSON.stringify(toasts));
			}

			this.toast.classList.remove(this.classes.visible);
		}

		toastFound() {
			return this.getStoredToasts().includes(this.ref);
		}

		handleAccept() {
			window.Shopify.customerPrivacy.setTrackingConsent(true, () => this.closeToast());
		}

		getStoredToasts() {
			try {
				return JSON.parse(localStorage.getItem('toasts')) || [];
			} catch {
				return [];
			}
		}

		onPageLoad(callback) {
			if (document.readyState === 'complete') {
				callback();
			} else {
				window.addEventListener('load', callback, { once: true });
			}
		}

		loadFeatures() {
			window.Shopify.loadFeatures(
				[{ name: 'consent-tracking-api', version: '0.1' }],
				(error) => {
					if (error) console.error('Failed to load consent-tracking-api:', error);
				}
			);
		}
	}

	if (!customElements.get('toast-component')) {
		customElements.define('toast-component', ToastsComponent);
	}
}
